export const APP_STATES = {
  SET_PAUSE_ACTIVATION: 'SET_PAUSE_ACTIVATION',
  SET_DATE: 'SET_APP_DATE',
  GET_WORKING_REGIME: 'GET_WORKING_REGIME'
}
